import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, delay, map, materialize, tap } from 'rxjs/operators';
import { flatMap } from 'rxjs/operators';

import { AuthenticationService } from '../shared/services';
import { ResetPasswordModel } from '../models/reset-password.model';

@Injectable()
export class ResetPasswordResolver
  implements Resolve<Observable<ResetPasswordModel>>
{
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const email = route.queryParamMap.get('email');
    const sc = route.queryParamMap.get('sc');
    if (!email || !sc) {
      return of(email).pipe(map((re) => new ResetPasswordModel(false)));
    } else {
      return of(email).pipe(
        map((re) => new ResetPasswordModel(true, email, sc))
      );
    }
  }
}
